const { debounce } = require('../utils.js');

export default () => {
    $('#loading').css('display', 'none'); // hide loading text
    $('#datafetch').css('display', 'grid');

    /** Function to get URL parameter
     **/
    var getUrlParameter = function getUrlParameter(sParam) {
        var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
            sParameterName,
            i;

            for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');

            if (sParameterName[0] === sParam) {
                return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
            }
        }
        return false;
    };

    let siteLang = document.getElementsByTagName('html')[0].getAttribute('lang');
    if(siteLang == 'sv-SE') {
        var disabledBrandStr = 'Detta varumärke finns ej tillgängligt med befintliga val';
    } else {
        var disabledBrandStr = 'This brand is not available with the current choises.';
    }

    const disabledBrands = [];

    $('#clearFilter').on('click', function() {
        window.history.replaceState(null, null, window.location.pathname); // reset URL
        $('.active').removeClass('active'); // remove active from buttons
        $('.brand-checkbox').prop('checked', false);
        getProductsByParam(getFilterChoices());
    });

    /*** 
     * On init
     * Load products if url parameter exists
     * */
    const tagParams = getUrlParameter('tags'); // Ex https://schibstedforbusiness.se/adformats?tags=CATEGORY
    const catsParams = getUrlParameter('cats'); // Ex https://schibstedforbusiness.se/adformats?cats=CATEGORY
    const brandsParams = getUrlParameter('brands'); // Ex https://schibstedforbusiness.se/adformats?brands=CATEGORY

    const buttonsToDisable = document.querySelectorAll('.adformat-filter-call-btn');

    let tagIds, catIds, brandIds = [];

    if (tagParams !== false) {
        $('#loading').css('display', 'grid'); // show loading text on loads
        $('.swoop-effect').css('display', 'block');
        $('#datafetch').css('display', 'none');

        tagIds = tagParams.split(',');

        if (tagIds.length > 0) {
            tagIds.forEach((tagId) => {
                $('.btn.tag[data-id="' + tagId + '"').addClass('active');
            });
        }
    }

    if (catsParams !== false) {
        $('#loading').css('display', 'grid'); // show loading text on load
        $('.swoop-effect').css('display', 'block');
        $('#datafetch').css('display', 'none');

        catIds = catsParams.split(',');

        if (catIds.length > 0) {
            catIds.forEach((catId) => {
                $('.btn.tag[data-id="' + catId + '"').addClass('active');
            });
        }
    }

    if (brandsParams !== false) {
        $('#loading').css('display', 'grid'); // show loading text on load
        $('.swoop-effect').css('display', 'block');
        $('#datafetch').css('display', 'none');

        brandIds = brandsParams.split(',');

        if (brandIds.length > 0) {
            brandIds.forEach((brandId) => {
                $('.input-prod-brand[data-id="' + brandId + '"').addClass('active');
            });
        }
    }

    getProductsByParam({
        tags: tagIds,
        cats: catIds,
        brands: brandIds,
    });

    /** 
    * Button click show related category page via AJAX
    **/

    function getProductsByParam(filterChoices) {

        // AJAX Function
        $('#loading').css('display', 'grid'); // show loading text
        $('.swoop-effect').css('display', 'block');
        $('#datafetch').css('display', 'none');
        
        jQuery.ajax({
            url: horizon.ajaxUrl,
            type: 'post',
            data: {
                action: 'data_fetch',
                tags: filterChoices.tags,
                cats: filterChoices.cats,
                brands: filterChoices.brands,
            },
            success: function(data) {

                jQuery('#datafetch').html(data);

                buttonsToDisable.forEach((buttonToDisable) => {
                    buttonToDisable.removeAttribute('disabled');
                });

                /**
                 * Disable / Enable font-end filtering by brands
                 * 
                 */
                let disabledBrands = document.querySelector('#inactiveBrands').value;
                disabledBrands = JSON.parse(disabledBrands); // object

                document.querySelectorAll('.brand-logo').forEach((label) => { // Enable logo checkbox
                    label.classList.remove('disabled');
                    label.children[0].classList.remove('inactive-img');
                    label.removeAttribute('title');
                });
                document.querySelectorAll('.brand-checkbox').forEach((input) => { // Enable logo image
                    input.removeAttribute('disabled');
                });

                if (typeof disabledBrands === 'object' && Object.keys(disabledBrands).length > 0) {
    
                    let disabledBrandValues = Object.values(disabledBrands);
    
                    if (disabledBrandValues.length > 0) {
                        disabledBrandValues.forEach(function(item) {
                            // Disable label
                            document.querySelectorAll('label.index-' + item).forEach((label) => {
                                label.classList.toggle('disabled');
                                label.setAttribute('title', disabledBrandStr);
                                label.children[0].classList.toggle('inactive-img');
                            });
    
                            //Disable input
                            document.querySelectorAll('input#index-' + item).forEach((input) => {
                                input.setAttribute('disabled', true);
                            });
    
                        });
                    }
                }

                // URL etc
                const recievedUrl = window.location.href;

                const goalParams = getUrlParameter('goal'); // Ex https://schibstedforbusiness.se/adformats?goal=CATEGORY

                if (goalParams !== false) {
                    $('#loading').css('display', 'grid'); // show loading text on load
                    $('.swoop-effect').css('display', 'block');
                    $('#datafetch').css('display', 'none');

                    let goalIds = goalParams.split(',');
                    if (goalIds.length > 0) {
                        goalIds.forEach((goalId) => {
                            $('.related-products-category-filter__button[data-id="' + goalId + '"').addClass('active');
                            $(".produkt__arkiv__object--link[data-term-id!='" + goalId +"'], .related-product-category--description[data-term-id!='" + goalId +"']").hide(); // Göm alla som inte är i denna cat
                            $(".produkt__arkiv__object--link[data-term-id='" + goalId +"'], .related-product-category--description[data-term-id='" + goalId +"']").show(); // Visa alla som är med i cat 
                        });
                    }
                }

                // Goal click
                $(".related-products-category-filter__button").on('click', function() {
                    const cat = $(this).attr("data-category-title");
                    let catId = $(this).attr("data-id");
                    
                    
                    if ($(this).hasClass('active')) { // If we press again (on active filter)
                        $(".produkt__arkiv__object--link").show(); // Disable / Show all products again
                        $(this).toggleClass('active'); // Color on button text
                        catId = 0;
                    } else {
                        $(this).toggleClass('active'); // Color on button text
                        $(".produkt__arkiv__object--link[data-term-id!='" + catId +"'], .related-product-category--description[data-term-id!='" + catId +"']").hide(); // Göm alla som inte är i denna cat
                        $(".produkt__arkiv__object--link[data-term-id='" + catId +"'], .related-product-category--description[data-term-id='" + catId +"']").show(); // Visa alla som är med i cat 
                    }
                    
                    const activeButtons = $(this).siblings('.active');

                    if (activeButtons !== $(this)) {
                        activeButtons.removeClass('active');
                    }

                    let toSetUrl = recievedUrl;

                    if (catId > 0) {
                        toSetUrl = recievedUrl + "goal=" + catId;
                    }

                    window.history.replaceState(null, null, toSetUrl);
                });

                $('#loading').css('display', 'none'); // hide loading text on success
                $('#datafetch').css('display', 'grid');
                
            }
        });
    }

    function getFilterChoices(buttonClass, tags, cats, brands) {
        const activeFilters = document.querySelectorAll(`${buttonClass}.active`);

        if (buttonClass === '.btn-prod-tag') {
            tags = [];
        }

        if (buttonClass === '.btn-prod-cat') {
            cats = [];
        }

        if (buttonClass === '.input-prod-brand') {
            brands = [];
        }

        if (activeFilters && activeFilters.length > 0) {
            activeFilters.forEach((activeFilter) => {
                const filterId = activeFilter.getAttribute('data-id');

                if (filterId && buttonClass === '.btn-prod-tag') {
                    tags.push(parseInt(filterId));
                }

                if (filterId && buttonClass === '.btn-prod-cat') {
                    cats.push(parseInt(filterId));
                }

                if (filterId && buttonClass === '.input-prod-brand') {
                    brands.push(parseInt(filterId));
                }
            });
        }

        let urlParam = '';

        if (tags && tags.length > 0) {
            urlParam += 'tags=' + tags.join(',') + '&';
        }

        if (cats && cats.length > 0) {
            urlParam += 'cats=' + cats.join(',') + '&';
        }

        if (brands && brands.length > 0) {
            urlParam += 'brands=' + brands.join(',') + '&';
        }

        if (urlParam.length > 0) {
            urlParam = '?' + urlParam;
        }

        if (urlParam.length === 0) {
            window.history.replaceState(null, null, window.location.pathname); // reset URL
        } else {
            window.history.replaceState(null, null, urlParam); // update URL
        }

        return {
            tags,
            cats,
            brands,
        };
    }

    const filterButtonClasses = [
        '.btn-prod-tag', // Köpsätt
        '.btn-prod-cat', // Kategori
        '.input-prod-brand', // Varumärke
    ];

    let filterChoices = {
        tags: [],
        cats: [],
        brands: [],
    };

    filterButtonClasses.forEach((filterButtonClass) => {
        const buttons = document.querySelectorAll(filterButtonClass);

        if (buttons && buttons.length > 0) {
            buttons.forEach((button) => {
                button.addEventListener('click', () => {
                    button.classList.toggle('active');
                    buttonsToDisable.forEach((buttonToDisable) => {
                        buttonToDisable.setAttribute('disabled', 'disabled');
                    });
                    filterChoices = getFilterChoices(filterButtonClass, filterChoices.tags, filterChoices.cats, filterChoices.brands);
                    getProductsByParam(filterChoices);
                });
            });
        }
    });

    /** Meilisearch */
    async function searchProducts(event) {

        const allProducts = $('.produkt__arkiv .all-products');
        const searchResults = $('.produkt__arkiv .search-results');
        const spinner = $('.produkt__arkiv .search-spinner');
        
        searchResults.addClass('hidden');
        
        const query = event.target.value;

        if (query === '') {
            allProducts.removeClass('hidden');
            return;
        }
        
        allProducts.addClass('hidden');

        spinner.removeClass('hidden');
        
        const body = new FormData();
        body.append('action', 'search');
        body.append('q', event.target.value);
        
        const response = await fetch(horizon.ajaxUrl, {
            body,
            method: 'POST',
        });

        spinner.addClass('hidden');
        
        const html = await response.json();
        searchResults.removeClass('hidden');

        let siteLang = document.getElementsByTagName('html')[0].getAttribute('lang');
        var noResultsStr = '<p>No results found</p>';
        if(siteLang == 'sv-SE') {
            noResultsStr = '<p>Inga resultat hittades</p>';
        }

        if (html.length > 0) {
            searchResults.html(html.join("\n"));
        } else {
            searchResults.html(noResultsStr);
        }
    }

    $('[name="adformatSearch"]').on('input', debounce(searchProducts, 300, false));
}

// Tooltip
$('.btn-prod-cat, .btn-prod-tag').each(function() {
    if ($(this).data('excerpt') !== '') {
        var tooltipContent = $(this).data('excerpt');
        $(this).append('<div class="tooltip-icon">i</div>');
        $(this).append('<div class="tooltip-content">'+ tooltipContent +'</div>');
    }
});
